"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveTabs = ResponsiveTabs;

var React = _interopRequireWildcard(require("react"));

var _core = require("@blueprintjs/core");

var _index = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

var _hooks = require("../../common/hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ResponsiveTabs(_ref) {
  var _classNames4;

  var className = _ref.className,
      defaultSelectedTabId = _ref.defaultSelectedTabId,
      onTabChange = _ref.onTabChange,
      items = _ref.items,
      muted = _ref.muted,
      outlined = _ref.outlined,
      props = _objectWithoutProperties(_ref, ["className", "defaultSelectedTabId", "onTabChange", "items", "muted", "outlined"]);
  /**
   * We cant attach refs to the tabs themselves, and cant wrap the tabs in a container div as
   * the tabs component won't work, so instead we have to attach them to the tab inner div and
   * then manually add the padding later... nasty.
   */


  var tabRefs = items.map(function () {
    return /*#__PURE__*/React.createRef();
  });
  var ref = /*#__PURE__*/React.createRef();
  var isMount = (0, _hooks.useIsMount)();

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showOverflow = _React$useState2[0],
      setShowOverflow = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      left = _React$useState4[0],
      setLeft = _React$useState4[1];

  var _React$useState5 = React.useState(),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      parentWidth = _React$useState6[0],
      setParentWidth = _React$useState6[1];

  var _React$useState7 = React.useState([]),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      tabWidths = _React$useState8[0],
      setTabWidths = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      leftValues = _React$useState10[0],
      setLeftValues = _React$useState10[1];

  var _React$useState11 = React.useState(props.selectedTabId || defaultSelectedTabId || items[0].id),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      selectedTabId = _React$useState12[0],
      setSelectedTabId = _React$useState12[1];
  /**
   * Resizing just sets the parent width
   */


  function handleResize(entries) {
    var parent = entries.find(function (entry) {
      return entry.target.classList.contains(_index.Classes.TABS_OVERFLOW_WRAPPER);
    });

    if (parent) {
      setParentWidth(Math.ceil(parent.contentRect.width));
    }
  }
  /**
   * Calculate tab widths on load
   */


  React.useEffect(function () {
    var widths = tabRefs.map(function (ref) {
      return ref.current ? ref.current.offsetWidth + 48 : 0;
    });
    setTabWidths(widths);
  }, []);
  React.useEffect(function () {
    var tabsWidth = tabWidths.reduce(function (sum, width) {
      return sum + width;
    }, 0);

    if (parentWidth && tabsWidth > 0) {
      /**
       * If the width of the tabs are less than the parent than show the overflow
       * indicators i.e. the weird opacity fade bookends.
       */
      setShowOverflow(parentWidth < tabsWidth);
      /**
       * We need to re-calculate the left values every time the parent resizes
       */

      var maxScroll = parentWidth ? tabsWidth - parentWidth : 0;

      var _leftValues = items.map(function (_item, index) {
        var itemWidth = tabWidths[index];
        var tabsWidthBeforeItem = tabWidths.slice(0, index + 1).reduce(function (sum, width) {
          return sum + width;
        }, 0);
        var newIdealLeft = parentWidth ? tabsWidthBeforeItem - parentWidth / 2 - itemWidth / 2 : 0;
        if (newIdealLeft < 0) return 0;
        return newIdealLeft < maxScroll ? newIdealLeft : maxScroll;
      });

      setLeftValues(_leftValues);
    }
  }, [parentWidth, tabWidths]);
  /**
   * If we manipulate the left values we're assuming we've gone through a resize event
   * so we will likely need to scroll the tabs
   */

  React.useEffect(function () {
    if (leftValues.length > 0) {
      // Scroll tabs
      var itemIndex = items.findIndex(function (item) {
        return item.id === selectedTabId;
      });
      setLeft(leftValues[itemIndex]);
    }
  }, [leftValues]);
  /**
   * This caters for the primary menu items in the overflow menu
   * We want to make sure if a primary menu item is clicked then we behave like a tab is clicked
   */

  function handlePrimaryMenuItemClick(item) {
    setSelectedTabId(item.id);
  }

  React.useEffect(function () {
    var selectedItem = items.find(function (item) {
      return item.id === selectedTabId;
    });

    if (selectedItem && !isMount) {
      if (onTabChange) onTabChange(selectedItem); // Scroll tabs

      if (leftValues.length > 0) {
        var itemIndex = items.findIndex(function (item) {
          return item.id === selectedTabId;
        });
        setLeft(leftValues[itemIndex]);
      }
    }
  }, [selectedTabId]); // Designed to produce all 3 tab styles: primary, secondary, and workflow
  // It's done this way so that we don't have to pass in the renderer

  var visibleItemRenderer = function visibleItemRenderer(item, index) {
    var disabled = item.disabled,
        id = item.id,
        iconProps = item.iconProps,
        count = item.count,
        text = item.text,
        menuItems = item.menuItems;
    var withCount = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      ref: tabRefs[index]
    }, iconProps && /*#__PURE__*/React.createElement(_index.Icon16, iconProps), Number.isInteger(count) && /*#__PURE__*/React.createElement(_index.Body, {
      style: {
        color: _index.Colors.EBONY_80
      },
      semiBold: true
    }, count)), /*#__PURE__*/React.createElement(_index.Body, {
      title: text
    }, text));
    var withoutCount = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      ref: tabRefs[index]
    }, iconProps && /*#__PURE__*/React.createElement(_index.Icon16, iconProps), /*#__PURE__*/React.createElement(_index.Body, {
      title: text
    }, text)));
    /**
     * The tab has padding and we're hacking this absolutely positioned div in so it sits on top of the content
     * and helps ensure that the entire tab is clickable
     */

    var hackyExpansiveDiv = /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        top: '-16px',
        left: '-24px',
        right: '-24px',
        bottom: '-16px'
      }
    });
    /**
     * Tags must be divs because we need a block level element to ensure styling
     * Seemingly random absolutely positioned div is to ensure entirety of tab is a clickable target
     */

    var withoutCountWithMenu = /*#__PURE__*/React.createElement(_index.Popover, {
      position: _index.Position.BOTTOM,
      autoFocus: false,
      targetTagName: "div",
      wrapperTagName: "div"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
      },
      ref: tabRefs[index]
    }, iconProps && /*#__PURE__*/React.createElement(_index.Icon16, iconProps), /*#__PURE__*/React.createElement(_index.Body, {
      title: text
    }, text), /*#__PURE__*/React.createElement(_index.Icon8, {
      icon: _index.IconNames8.CARET_DOWN,
      style: {
        margin: '0 0 0 8px',
        fill: _index.Colors.GREY_50
      },
      fill: _index.Colors.GREY_50,
      fillOpacity: 0.4
    }), hackyExpansiveDiv), /*#__PURE__*/React.createElement(_index.Menu, null, (menuItems || []).map(function (menuItem) {
      return menuItemRenderer(menuItem);
    })));
    var tabContent = Number.isInteger(count) ? withCount : menuItems ? withoutCountWithMenu : withoutCount;
    /**
     * Ensure that for accessibility purposes we use a proper anchor tag where possible
     */

    if (item.href) {
      return /*#__PURE__*/React.createElement(_index.Tab, {
        id: id,
        disabled: disabled,
        key: id
      }, /*#__PURE__*/React.createElement("a", {
        href: item.href,
        style: {
          position: 'relative',
          display: 'block'
        }
      }, tabContent, hackyExpansiveDiv));
    }

    return /*#__PURE__*/React.createElement(_index.Tab, {
      id: id,
      disabled: disabled,
      key: id
    }, tabContent);
  };
  /**
   * Had to be done with two returns as empty children passed to a MenuItem will still
   * result in a blank sub menu appearing
   * @param menuItem
   */


  var menuItemRenderer = function menuItemRenderer(_ref2) {
    var href = _ref2.href,
        menuItems = _ref2.menuItems,
        rest = _objectWithoutProperties(_ref2, ["href", "menuItems"]);

    var isActive = window.location.pathname === href || (menuItems || []).map(function (_ref3) {
      var href = _ref3.href;
      return href;
    }).includes(window.location.pathname);

    var menuItemProps = _objectSpread(_objectSpread({}, rest), {}, {
      active: isActive,
      href: href,
      key: "".concat(href, "-").concat(rest.text)
    });

    if (!menuItems) {
      return /*#__PURE__*/React.createElement(_index.MenuItem, menuItemProps);
    }

    return /*#__PURE__*/React.createElement(_index.MenuItem, menuItemProps, menuItems.map(function (subItem) {
      return menuItemRenderer(subItem);
    }));
  };

  function maybeRenderOverflow() {
    if (!showOverflow) return null;
    return overflowRenderer(items);
  }

  var overflowRenderer = function overflowRenderer(overflowItems) {
    return /*#__PURE__*/React.createElement(_index.Popover, {
      position: _index.Position.BOTTOM_LEFT,
      autoFocus: false
    }, /*#__PURE__*/React.createElement(_index.IconButton40, {
      icon: _index.IconNames16.OVERFLOW,
      role: "Menu Trigger"
    }), /*#__PURE__*/React.createElement(_index.Menu, null, overflowItems.map(function (item) {
      var id = item.id,
          iconProps = item.iconProps,
          menuItems = item.menuItems,
          rest = _objectWithoutProperties(item, ["id", "iconProps", "menuItems"]);
      /**
       * For primary items we want to ensure that we treat a click like a tab click
       */


      var handleClick = function handleClick() {
        handlePrimaryMenuItemClick(item);
      };

      var menuItemProps = _objectSpread(_objectSpread({}, rest), {}, {
        key: id,
        active: id === selectedTabId,
        icon: iconProps && /*#__PURE__*/React.createElement(_index.Icon16, iconProps),
        onClick: handleClick
      });

      if (!menuItems) {
        return /*#__PURE__*/React.createElement(_index.MenuItem, menuItemProps);
      }

      return /*#__PURE__*/React.createElement(_index.MenuItem, menuItemProps, menuItems.map(function (subItem) {
        return menuItemRenderer(subItem);
      }));
    })));
  };

  var wrapperClasses = (0, _classnames.default)(_defineProperty({}, _index.Classes.OUTLINED, outlined), _defineProperty({}, _index.Classes.MUTED, muted), _index.Classes.TABS_OVERFLOW_WRAPPER);
  var overflowedClasses = (0, _classnames.default)(_defineProperty({}, _index.Classes.OVERFLOWED, showOverflow));
  var tabsClasses = (0, _classnames.default)((_classNames4 = {}, _defineProperty(_classNames4, _index.Classes.MUTED, muted), _defineProperty(_classNames4, _index.Classes.OUTLINED, outlined), _classNames4), _index.Classes.FOCUS_DISABLED, className);
  /**
   * Generating these in the JS as its easier due to needing to manipulate their background colour etc
   * Top 2px is there so we ensure we're always showing the outline border if it exists
   * There should never be any actual content in the top 2px so we don't have to worry that we're not
   * leaving some unblurred content at the top
   */

  var overflowIndicatorStyles = {
    position: 'absolute',
    zIndex: 1,
    top: '2px',
    bottom: 0,
    width: '24px'
  }; // NOTE: Cant use transparent as a background colour as it doesn't have great cross browser compatibility
  // Specifically Safari doesn't deal with it well and uses a transparent black ¯\_(ツ)_/¯

  var backgroundColor = muted ? _index.Colors.IVORY_05 : _index.Colors.SAGE_50;
  var transparentColor = muted ? 'rgba(252,250,242,0)' : 'rgba(69,92,81,0)';
  var overflowIndicatorLeft = /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, overflowIndicatorStyles), {}, {
      background: "linear-gradient(to left, ".concat(transparentColor, " 0%, ").concat(backgroundColor, " 50%)"),
      left: 0
    })
  });
  var overflowIndicatorRight = /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, overflowIndicatorStyles), {}, {
      background: "linear-gradient(to right, ".concat(transparentColor, " 0%, ").concat(backgroundColor, " 50%)"),
      right: '64px'
    })
  });
  var showOverflowIndicatorLeft = left !== 0 && showOverflow;
  var showOverflowIndicatorRight = left !== Math.max.apply(Math, _toConsumableArray(leftValues)) && showOverflow; // Tabs expects its direct children to ONLY be tabs

  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses,
    ref: ref
  }, showOverflowIndicatorLeft && overflowIndicatorLeft, /*#__PURE__*/React.createElement(_core.ResizeSensor, {
    onResize: handleResize,
    observeParents: true
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      left: "-".concat(left, "px")
    },
    className: overflowedClasses
  }, /*#__PURE__*/React.createElement(_core.Tabs, _extends({
    className: tabsClasses
  }, props, {
    selectedTabId: selectedTabId,
    onChange: setSelectedTabId
  }), items.map(function (item, index) {
    return visibleItemRenderer(item, index);
  })))), showOverflowIndicatorRight && overflowIndicatorRight, maybeRenderOverflow());
}